// extracted by mini-css-extract-plugin
export default {"Splash":"Splash_Splash__ODIe1"};